"use strict";

exports.__esModule = true;
exports.sortArrayOfObjectsByKey = void 0;
var path = require("ramda").path;
function getValueForKey(object, key) {
  if (Array.isArray(key)) {
    return path(key, object);
  }
  return object[key];
}
var sortArrayOfObjectsByKey = exports.sortArrayOfObjectsByKey = function sortArrayOfObjectsByKey(array, key) {
  return array.sort(function (a, b) {
    var textValueA = getValueForKey(a, key);
    var textValueB = getValueForKey(b, key);
    var textA = typeof textValueA === "string" ? textValueA.toUpperCase() : textValueA;
    var textB = typeof textValueB === "string" ? textValueB.toUpperCase() : textValueB;
    var comparison = 0;
    if (textA > textB) {
      comparison = 1;
    } else if (textA < textB) {
      comparison = -1;
    }
    return comparison;
  });
};